"use client";

import React from "react";

const reasons = [
  {
    title: "Trusted & Reliable",
    description:
      "A trusted name, backed by Voyage Plus – a pioneer in the travel industry.",
    icon: "las la-shield-alt",
    color: "#2198d8",
    gradient: "from-[#2198d8] via-[#2198d8] to-[#2198d8]",
    // glow: "bg-[#019EE7]/15",
  },
  {
    title: "Best Price Promise",
    description:
      "Competitive pricing with exclusive offers for both business and personal travel.",
    icon: "las la-tags",
    color: "#2198d8",
    gradient: "from-[#2198d8] via-[#2198d8] to-[#2198d8]",
    // glow: "bg-[#97BF49]/15",
  },
  {
  title: "Personalized Service",
  description:
    "Personalized service tailored to both corporate and leisure travelers.",
  icon: "las la-user-tie",
  color: "#2198d8",
  gradient: "from-[#2198d8] via-[#2198d8] to-[#2198d8]",
  // glow: "bg-[#EC4899]/15",
},
  {
    title: "Global Network",
    description:
      "A global network ensuring reliability and coverage across continents.",
    icon: "las la-globe",
    color: "#2198d8",
    gradient: "from-[#2198d8] via-[#2198d8] to-[#2198d8]",
    // glow: "bg-[#8B5CF6]/15",
  },
  {
    title: "24/7 Support",
    description:
      "Professional, multilingual team dedicated to client satisfaction.",
    icon: "las la-headset",
    color: "#2198d8",
    gradient: "from-[#2198d8] via-[#2198d8] to-[#2198d8]",
    // glow: "bg-[#F59E0B]/15",
  },
];

function Whyvoyage() {
  return (
    <section className="container mx-auto max-w-7xl px-5">
      <div className="relative overflow-hidden rounded-[28px] py-4 sm:py-12 lg:pb-14">
        <div className="relative z-10 mx-auto max-w-5xl md:text-center text-left">
          {/* SMALL LABEL */}
          <div className="mx-auto mb-2 flex items-center md:justify-center justify-left gap-4">
            <span className=" inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
               Why Choose Us
              </span>
          </div>

          {/* HEADING */}
          <h2 className="m-0 text-[25px] font-semibold leading-[1.1] tracking-[0.2px] text-[#12344A] sm:text-[48px] md:text-[58px] lg:text-[50px]">
            Your Journey, <span className="text-[#12344A]">Our Priority.</span>
          </h2>

          {/* DESCRIPTION */}
          <p className="mx-auto md:mt-4 mt-2 max-w-3xl text-[16px] font-medium leading-7 text-slate-500 sm:text-[18px] sm:leading-8 lg:text-[20px]">
            With expertise, care and a global network,
            <br className="hidden sm:block" />
            we create seamless travel experiences you can trust.
          </p>
        </div>

        {/* CARDS */}
        <div className="relative z-10 mt-12 grid grid-cols-1 md:gap-2 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {reasons.map((reason) => (
            <article
              key={reason.title}
              className="group relative flex md:min-h-[320px] flex-col overflow-hidden rounded-[22px] border border-[#DDE8EE] bg-white px-6 pb-7 pt-3 text-center shadow-[0_10px_30px_rgba(18,52,74,0.06)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_45px_rgba(18,52,74,0.12)]"
            >
              {/* ICON AREA */}
              <div className="relative mx-auto flex md:h-[145px] w-full items-center justify-center">

                {/* ICON GLOW */}
                {/* <div
                  className={`absolute inset-0 mx-auto my-auto h-[125px] w-[125px] scale-75 rounded-full opacity-0 blur-2xl transition-all duration-500 group-hover:scale-125 group-hover:opacity-70 ${reason.glow}`}
                /> */}

                {/* OUTER CIRCLE */}
                <div
                  className="relative flex h-[82px] w-[82px] items-center justify-center rounded-full  bg-[#FEFEFE] transition-all duration-500 group-hover:scale-110"
                >
                  {/* INDIVIDUAL COLOR ICON */}
                  <div
                    className={`border border-sky-600 relative flex h-[64px] w-[64px] items-center justify-center overflow-hidden rounded-full bg-[#f5f5f5] group-hover:bg-gradient-to-br ${reason.gradient} transition-all duration-500 group-hover:scale-110`}
                    // style={{
                    //   boxShadow: `0 10px 25px ${reason.color}40`,
                    // }}
                  >
                    {/* GLOSSY HIGHLIGHT */}
                    {/* <span className="absolute left-[9px] top-[6px] h-[9px] w-[25px] rotate-[-25deg] rounded-full bg-white/60 blur-[1px]" /> */}

                    {/* TOP GLOW */}
                    <span className="absolute right-[-5px] top-[-5px] h-[25px] w-[25px] rounded-full bg-white/25 blur-md" />

                    {/* ICON */}
                    <i
                      className={`${reason.icon} relative z-10 text-[40px] text-sky-600 group-hover:text-white `}
                    />
                  </div>
                </div>

                {/* DECORATIVE DOTS */}
                <div className="absolute right-[5%] top-[45px] grid grid-cols-3 gap-2 opacity-40">
                  {[...Array(9)].map((_, dotIndex) => (
                    <span
                      key={dotIndex}
                      className="h-[4px] w-[4px] rounded-full"
                      style={{
                        backgroundColor:
                          dotIndex % 2 === 0 ? reason.color : "#DDE8EE",
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* TITLE */}
              <h3 className="m-0 min-h-[52px] text-[21px] font-extrabold leading-[1.25] tracking-[-0.5px] text-[#12344A] sm:text-[22px] md:pt-0 pt-6">
                {reason.title}
              </h3>

              {/* TITLE LINE */}
              <div
                className="mx-auto mt-5 h-[3px] w-11 rounded-full transition-all duration-300 group-hover:w-16"
                style={{
                  backgroundColor: reason.color,
                }}
              />

              {/* DESCRIPTION */}
              <p className="m-0 mt-6 text-[15px] font-medium leading-6 text-[#536B7A] sm:text-[16px]">
                {reason.description}
              </p>

              {/* BOTTOM ACCENT */}
              <div
                className="absolute bottom-0 left-0 h-[4px] w-full transition-all duration-500 group-hover:h-[6px]"
                style={{
                  backgroundColor: reason.color,
                }}
              />

              {/* CORNER GLOW */}
              <div
                className="pointer-events-none absolute -bottom-16 -right-16 h-32 w-32 rounded-full opacity-0 blur-3xl transition-all duration-500 group-hover:opacity-30"
                style={{
                  backgroundColor: reason.color,
                }}
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Whyvoyage;